import { instance } from '@/utils/http.js'
 
  
 
export const getSkbSubject = (params) => {
  return instance({
    url: 'api/v1/user/skbSubject',
    method: 'get',
    params
  })
}

 
export const skbDoPaper = (data) => {
  return instance({
    url: '/api/v1/user/skbDoPaper',
    method: 'post',
    data
  })
}
export const skbContinuePaper = (data) => {
  return instance({
    url: '/api/v1/user/skbContinuePaper',
    method: 'post',
    data
  })
}
 
export const skbSubmitAnswer = (data) => {
  return instance({
    url: '/api/v1/user/skbSubmitAnswer',
    method: 'post',
    data
  })
}
export const skbSubmitUserAnswer = (data) => {
  return instance({
    url: '/api/v1/user/skbSubmitUserAnswer',
    method: 'post',
      noloading: true,
    data
  })
} 

export const skbUserPaper = (params) => {
  return instance({
    url: '/api/v1/user/skbUserPaper',
    method: 'get',
    params
  })
} 

export const skbPaperAnalysis= (params) => {
  return instance({
    url: '/api/v1/user/skbPaperAnalysis',
    method: 'get',
    params
  })
} 
 
export const getPaper= (params) => {
  return instance({
    url: '/api/v1/user/getPaper',
    method: 'get',
    params
  })
} 
 
 
 